'use strict';

import $ from 'jquery';

// Av ngn magisk anledning måste denna importeras, även om den inte anv av denna kod. Har kanske att göra med att det är jQuery och inte 'äkta' modulariserat?
// eslint-disable-next-line no-unused-vars
import dt from 'datatables.net';

let initiera = function (dataTableData)
{
	return $('#_ss-tabellen_kropp').DataTable({

		data: dataTableData,

		ordering: false,

		dom: 't',	/* Se https://datatables.net/reference/option/dom */
		searching: true,
		/* Sätt den initiala filtreringen: */
		/* Kan även göras med API, så här: tabellen.column(5).search('true').draw(); och '' invaliderar filtret. */
		searchCols: [
			null
			, null
			, null
			, null
			, null
			, { search: '' }		// Initialt visas radtexter.
			, { search: 'false' }	// Initialt visas *inte* rättelser.
			, { search: 'false' }	//  — " —
		],

		language: {
			loadingRecords: 'Laddar...',
			processing: 'Bearbetar...',
			emptyTable: 'Inga transaktioner att visa',
			zeroRecords: 'Inga transaktioner matchar ditt filter &nbsp; :('	/* Avser endast filtreringsresultatet! */
		},
		paging: false,
		info: false,
		processing: false,
		autoWidth: false,
		deferRender: true,

		/* Anv inte, bl.a. p.g.a... se kommentar i Kontoutdrag.cshtml */
		stateSave: false,
		/* Kan invalideras med tabellen.state.clear(); */

		responsive: false,	/* Extension som vi inte anv f.n. */

		columnDefs: [
			{ name: 'konto', targets: 0 }
			, { name: 'benamning', targets: 1, className: 'nw' }
			, { name: 'debet', targets: 2, className: 'hj' }
			, { name: 'kredit', targets: 3, className: 'hj' }
			, { name: 'auto', targets: 4, className: 'fst' }
			// ----- Visas inte:
			, { name: 'radtext', targets: 5, visible: false }
			, { name: 'rattelsenot', targets: 6, visible: false }
			, { name: 'struken', targets: 7, visible: false }
		],

		createdRow(row, data, index)
		{
			let radtext = data[5];
			let rattelsenot = data[6];
			let struken = data[7];

			if (!!radtext || !!rattelsenot)
			{
				// Styla hela raden (style vid hover av ovanliggande rad):
				row.classList.add('-underrad');
			}

			/* Radtext-rad: */
			if (radtext)
			{

				/* Ta bort kol 1 (0–n): */
				$('td', row).eq(1).remove();

				/* Sätt colspan på kol 0 (0–n): */
				$('td', row).eq(0).attr('colspan', 2);

				/* Styla alla cellerna: */
				$('td', row).addClass('rt');
			}


			/* Rättelsenoterings-rad: */
			if (rattelsenot)
			{

				/* Ta bort kol 1 (0–n): */
				$('td', row).eq(1).remove();

				/* Sätt colspan på kol 0 (0–n): */
				$('td', row).eq(0).attr('colspan', 2);

				/* Styla alla cellerna: */
				$('td', row).addClass('rn');
			}


			/* Raden, oavsett slag ovan, ska vara struken: */
			if (struken)
			{

				/* Styla alla cellerna: */
				$('td', row).addClass('str');
			}


			/* Rättelsenoterings-rad, som *inte* är struken i sig, men som har en struken rad ovanför: */
			if (!!rattelsenot
				&& !struken
				&& !!dataTableData[index - 1][7])
			{

				/* Styla alla cellernas bakgrund: */
				$('td', row).addClass('str-bg');
			}
		},
	});

};

let ssoVerifikatDatatable = { 
	// Methods:
	initiera,
};

export { ssoVerifikatDatatable };
